import { PublicInfoLayout } from "./PublicInfoLayout";

const Section = ({ title, children }) => (
  <section>
    <h2 className="font-heading text-2xl font-semibold tracking-tight text-white">
      {title}
    </h2>
    <div className="mt-3 space-y-3 text-zinc-400">{children}</div>
  </section>
);

export default function Privacy() {
  return (
    <PublicInfoLayout eyebrow="Privacy Policy" title="How we handle your data">
      <p className="text-zinc-400">
        Kirubeezy Studios collects only the
        information needed to provide course access, account support, and a
        reliable learning experience.
      </p>

      <Section title="Information we collect">
        <p>
          We may receive your name, email address, authentication status,
          subscription status, and course access activity through the services
          that power this site, including our authentication and payment
          providers.
        </p>
      </Section>

      <Section title="How we use it">
        <p>
          We use account and access information to sign you in, verify course
          eligibility, provide dashboard access, respond to support requests,
          and protect the site from misuse.
        </p>
      </Section>

      <Section title="Sharing and storage">
        <p>
          We do not sell personal information. Data may be processed by trusted
          service providers that help us run authentication, hosting, analytics,
          payment, email, database, and video delivery systems.
        </p>
      </Section>

      <Section title="Your choices">
        <p>
          You can request account help, data correction, or deletion by using
          the contact page. Some records may be retained when required for
          security, fraud prevention, legal compliance, or transaction history.
        </p>
      </Section>
    </PublicInfoLayout>
  );
}
